import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tm-dynamic-assessment',
  templateUrl: './tm-dynamic-assessment.component.html',
  styleUrls: ['./tm-dynamic-assessment.component.scss']
})
export class TmDynamicAssessmentComponent implements OnInit {


  @Input() masters;
  @Input() form_group;
  @Input() section;
  @Input() field;
  @Input() disabled;

  constructor() { }

  ngOnInit(): void {
  }
}
